import {
  createProgramConverter,
  createProgramFeatureUserConverter,
  PointsBucket,
  ProgramFeatureUser,
  createPointsBucketConverter,
  createIncentivesConfigConverter,
} from "@t3/shared";
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { Program, IncentivesConfig } from "@t3/shared";

export const programConverter = createProgramConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<Program, DocumentData>;

export const programFeatureUserConverter = createProgramFeatureUserConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<ProgramFeatureUser, DocumentData>;

export const pointsBucketConverter = createPointsBucketConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<PointsBucket, DocumentData>;

export const incentivesConfigConverter = createIncentivesConfigConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<IncentivesConfig, DocumentData>;
